import React, { useCallback, useEffect, useState, forwardRef, useContext, useRef } from "react";

import { Chat24Filled, Dismiss24Regular, EmojiRegular, SendFilled, AttachRegular } from "@fluentui/react-icons";
import FluentChatOverlay from "./FluentChatOverlay";
import { ChatContext, useChat } from "../hooks/useChat";
import { MAX_MESSAGE_LENGTH } from "../../utils/chat-message";

export default function FluentChatPublic({
  scene,
  hubChannel,
  presences,
  mySessionId,
  canTextChat,
  canSendChat = true,
  ...rest
}) {
  const [message, setMessage] = useState("");
  const inputRef = useRef();
  const [isCommand, setIsCommand] = useState(false);

  const { messageGroups, sendMessage, sendMessageSpawn, setMessagesRead, unreadMessages } = useContext(ChatContext);
  // Clear the unread badge whenever the General tab is mounted or a new message arrives
  // while the user is already viewing it — the badge self-dismisses for active viewers.
  useEffect(() => {
    if (unreadMessages) setMessagesRead();
  }, [unreadMessages, setMessagesRead]);
  const typingTimeoutRef = useRef();
  const { isDisabled, onSendMessage, onKeyDown, onUploadAttachments, onSpawn, onSelectEmoji } = useChat({
    inputRef,
    message,
    scene,
    canTextChat: canTextChat && canSendChat,
    sendMessage,
    setMessage,
    sendMessageSpawn,
    isCommand,
    setIsCommand,
    typingTimeoutRef
  });

  return (
    <>
      <FluentChatOverlay
        hubChannel={hubChannel}
        scene={scene}
        messageGroups={messageGroups}
        onSendMessage={onSendMessage}
        onUploadAttachments={onUploadAttachments}
        onKeyDown={onKeyDown}
        message={message}
        setMessage={setMessage}
        isDisabled={isDisabled}
        isCommand={isCommand}
        onSpawn={onSpawn}
        onSelectEmoji={onSelectEmoji}
        canTextChat={canTextChat}
        {...rest}
      />
    </>
  );
}

export const ChatMessageList = forwardRef(({ children, ...rest }, ref) => (
  <ul {...rest} ref={ref}>
    {children}
  </ul>
));

ChatMessageList.displayName = "ChatMessageList";
